import React from "react";
import "../index.css";

const Keyboard = ({ keyboardRows, keyboardState, onKeyClick }) => (
  <div className="keyboard">
    {keyboardRows.map((row, i) => (
      <div key={i} className="keyboard-row">
        {row.map((key) => {
          const keyStatus = keyboardState[key] || "";
          const isSpecial = key === "Enter" || key === "Backspace";
          return (
            <button
              key={key}
              className={`key ${keyStatus} ${isSpecial ? "wide" : ""}`}
              onClick={() => onKeyClick(key)}
              aria-label={key}
            >
              {key === "Backspace" ? "⌫" : key}
            </button>
          );
        })}
      </div>
    ))}
  </div>
);

export default Keyboard;